import { Position } from "@blueprintjs/core"
import CustomPopover, {
  CustomPopoverProps,
} from "components/Atoms/CustomPopover"
import React from "react"

interface PopoverTooltipProps extends CustomPopoverProps {
  children: any
  trigger: any
}
const PopoverTooltip = ({
  children,
  trigger,
  ...otherProps
}: PopoverTooltipProps) => {
  return (
    <CustomPopover
      position={Position.BOTTOM_LEFT}
      minimal={true}
      interactionKind="hover"
      content={children}
      {...otherProps}
    >
      {trigger}
    </CustomPopover>
  )
}

export default PopoverTooltip
